// extracted by mini-css-extract-plugin
module.exports = {"preloader":"_025a50318d--preloader--29Cf6","spin":"_025a50318d--spin--3gYXq"};